module.exports = __webpack_public_path__ + "img/img9.2b0b3261.png";